module.exports = __webpack_public_path__ + "img/comercio_mayoreo.5a83e829.svg";